export const FEEDBACK = "https://forms.gle/iazJCg8uQ6c2rFGJ9";
